import { DisplayObject } from "@pixi/display";

export function assignOnEnterFrameFunction<T extends DisplayObject>(target: T, onEnterFrame: (this: T) => void) {
  return Object.assign(target, { onEnterFrame });
}
